import { TenantStatus } from "@/services/tenant-service/entities/Enums.ts";

export class TenantInfo {
  readonly guid: string;
  isDeleted: boolean;
  isDisposed: boolean;
  name: string;
  sequenceNumber: number;
  status: TenantStatus;
  version: string;
  databaseConfigOption: string;
  licenceInfo: LicenceInfo;
  owner: TenantOwner;
  versionNumber: number;
  workingTenant?: string;

  constructor(data?: Record<string, any>) {
    this.guid = data?.guid || "";
    this.isDeleted = data?.isDeleted || false;
    this.isDisposed = data?.isDisposed || false;
    this.name = data?.name || "";
    this.workingTenant = data?.workingTenant;
    this.sequenceNumber = data?.sequenceNumber || 0;
    this.status = data?.status || TenantStatus.ACTIVE;
    this.version = data?.version || "";
    this.databaseConfigOption = data?.tenantInfo?.databaseConfigOption || "";
    this.licenceInfo = new LicenceInfo(data?.tenantInfo?.licenceInfo);
    this.owner = new TenantOwner(data?.tenantInfo?.owner);
    this.versionNumber = data?.tenantInfo?.versionNumber || 0;
  }

  get disabled(): boolean {
    return this.status === TenantStatus.INACTIVE;
  }
}

export class LicenceInfo {
  expiredTime: string;
  licenceType: string;
  licenseAvailability: LicenseAvailability;

  constructor(data?: Record<string, any>) {
    this.expiredTime = data?.expiredTime || "";
    this.licenceType = data?.licenceType || "";
    this.licenseAvailability = new LicenseAvailability(data?.licenseAvailability);
  }
}

export class LicenseAvailability {
  externalOrganizations: TenantAvailability;
  resources: TenantAvailability;

  constructor(data?: Record<string, any>) {
    this.externalOrganizations = new TenantAvailability(data?.externalOrganizations);
    this.resources = new TenantAvailability(data?.resources);
  }
}

export class TenantAvailability {
  committed: number;
  total: number;
  used: number;

  constructor(data?: Record<string, number>) {
    this.committed = data?.committed || 0;
    this.total = data?.total || 0;
    this.used = data?.used || 0;
  }
}

export class TenantOwner {
  email: string;
  name: string;
  phoneNumber: string;

  constructor(data?: Record<string, string>) {
    this.email = data?.email || "";
    this.name = data?.name || "";
    this.phoneNumber = data?.phoneNumber || "";
  }
}


export interface ITenantConfig {
  culture: string;
  dateFormat: string;
  dateTimeFormat: string;
  tenantId: string;
  timeFormat: string;
  timezone: string;
}
